import * as React from "react"
import { AudioPlayerContext } from "./AudioPlayerContext.tsx"

export const useAudioPlayer = () => {
  const context = React.use(AudioPlayerContext)
  if (!context) {
    throw new Error("useAudioPlayerContext must be used within a AudioPlayerContextProvider")
  }
  return context
}
